import axiosApi from "core/request";

import { googleLogout } from '@react-oauth/google';
import { createAsyncThunk } from "@reduxjs/toolkit";

interface ILoginForm {
  username: string;
  password: string;
}

interface IGoogleLoginForm {
  externalAccessToken: string;
}

export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }: ILoginForm, { rejectWithValue }) => {
    try {
      const response = await axiosApi.post("account/login", {
        username: username,
        password: password,
      });
      return response.data;
    } catch (err) {
      const error = err as any;
      const errorTitle = error?.response?.data;
      if (error.response?.status === 400 && error.response?.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(errorTitle);
    }
  },
);

export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async ({ externalAccessToken }: IGoogleLoginForm, { rejectWithValue }) => {
    try {
      const response = await axiosApi.post("account/internalTokenByExternal", {
        externalAccessToken,
      });
      return response.data;
    } catch (err) {
      const error = err as any;
      const errorTitle = error?.response?.data;
      if (error.response?.status === 400 && error.response?.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(errorTitle);
    }
  },
);

export const logout = createAsyncThunk("auth/logout", async () => {
  try {
    const response = await axiosApi.post("account/logoutall");
    googleLogout();

    return response.data;
  } catch (err) {
    console.log(err);
  }
});

export const getUserInfo = createAsyncThunk(
  "auth/userInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosApi.get("account/userinfo");
      return response.data;
    } catch (err) {
      //TODO
      return rejectWithValue("Error");
    }
  },
);

export const getAllowedMenus = createAsyncThunk(
  "auth/allowedMenus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosApi.get("account/allowedmenus");
      return response.data;
    } catch (err) {
      //TODO
      return rejectWithValue("Error");
    }
  },
);

export const getAllowedGroupsByMenuId = createAsyncThunk(
  "auth/allowedGroupsByMenuId",
  async (menuId: number, { rejectWithValue }) => {
    try {
      const response = await axiosApi.get(
        `account/allowedgroupsbymenuid?id=${menuId}`,
      );
      return response.data;
    } catch (err) {
      //TODO
      return rejectWithValue("Error");
    }
  },
);

export const getAllowedPermissionsByGroupId = createAsyncThunk(
  "auth/allowedPermissionsByGroupId",
  async (groupId: number, { rejectWithValue }) => {
    try {
      const response = await axiosApi.get(
        `account/allowedpermissionsbygroupid?permissionGroupId=${groupId}`,
      );
      return response.data;
    } catch (err) {
      //TODO
      return rejectWithValue("Error");
    }
  },
);
